import React from 'react'

// Import common components
import Ideate from './Ideate'
import Design from './Design'
import Build from './Build'
import ProcessItem from './ProcessItem'

// Themes
import IMAGES from '../../../themes/Image'

// Process components
import {
  Wrapper,
  MainTitle,
  StartButton,
  QuestionTitle
} from './ProcessResponsive'

export default (props) => {
  const { handleToggleModal } = props

  const data = [
    {
      image: IMAGES.ideate,
      icon: (isAnimate, scale) => { return <Ideate scale={scale} isAnimate={isAnimate} /> },
      iconText: 'Ideate',
      description: 'All of our games begin with the ideation process in which our product team works directly with the Client to confirm all aspects of the game. This includes; target user base, competition research, technical specifications, and user journeys.',
      id: 'ideate'
    },
    {
      image: IMAGES.design,
      icon: (isAnimate, scale) => { return <Design scale={scale} isAnimate={isAnimate} /> },
      iconText: 'Design',
      description: 'With our highly experienced design team, we begin with mock sketches for all visual elements within the game.  Once confirmed we move onto the user interface design. Our team also focuses on intricate animations and sound design.',
      id: 'design'
    },
    {
      icon: (isAnimate, scale) => { return <Build scale={scale} isAnimate={isAnimate} /> },
      iconText: 'Build',
      description: 'Once all the design is complete, our full stack engineers work closely with the Client to build out the entire game. We work in an agile methodology so we are consistently delivering work on a weekly or bi-weekly basis.',
      id: 'build'
    }
  ]

  return (
    <Wrapper>
      <MainTitle
        type='large'
        title='Our Process'
      />
      {
        data.map((item, index) => {
          return (
            <ProcessItem
              item={item}
              key={index}
            />
          )
        })
      }

      <QuestionTitle
        type='base'
        title='Want to make your game a reality?'
      />

      <StartButton
        type='primary'
        text='Start Your Agility Experience'
        onPress={handleToggleModal}
      />
    </Wrapper>
  )
}



// WEBPACK FOOTER //
// ./src/components/sections/process/Process.js